import axios from "../../plugins/axios";

export const actions = {
    obterCliente(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('cliente/' + payload.valor)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/cliente.js